export default __webpack_public_path__ + "static/media/delete-user.015e8224.png";